import { RouterOutputs, trpc } from "../trpc";

export type App = RouterOutputs["app"]["apps"]["results"][number];

interface Input {
  slug?: string;
  selectedApi?: string;
}

export function useQueryApp({ slug, selectedApi }: Input) {
  const { data, isLoading } = trpc.app.app.useQuery(
    {
      slug,
      selectedApi,
    },
    {
      enabled: !!slug || !!selectedApi,
    },
  );

  return {
    app: data || undefined,
    isLoading,
  };
}
